import React, { useState, useEffect } from 'react';
import { BasicInfo } from './BasicInfo';
import SetFrequency from './SetFrequency';
import AddTask from './AddTask';
import AddDuration from './AddDuration';
import { RecommendResource } from './RecommendResource';
import { ModalComponent } from "common/ModalComponent";
import {
  Button
} from 'carbon-components-react';
import moment from 'moment';
import i18n from "../../i18n";
import * as Constants from '../../requests/URLConstants'
import callPostApi from "../../requests/PostRequests";
import { useHistory } from 'react-router-dom';

require("./_basic-info.scss");

require("./_manage-schedule.scss");

export const ReviewSubmit = props => {

  const modalFooterLoginSession = () => ({
    primaryButtonText: "OK",
    primaryButtonKind: "primary",

  });
  const [workNotesRequest, setWorkNotesRequest] = useState({
    upload_state: false,
    loaded: 0,
  });
  // const handleClickLogin = () => {
  //   setShowModal(!showModal)
  //   //handle the event. if anything has tobe performed on this.
  //   return null;
  // }
  let user = JSON.parse(localStorage.getItem('user'));
  const [review, setReview] = useState(true);
  const submit = i18n.t('manageschedule.submit');
  const [message, setMessage] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [timeFilterSelections, setTimeFilterSelections] = useState(props.timeFilterSelections)
  useEffect(() => {

  }, [message])
  const history = useHistory();

  var frequencyweek = props.frequencyWeek;
  var frequencyweekday = props.frequencyWeekDay;
  var calendarname = props.calendarName;
  var calendarnameoptions = props.calendarNameOptions;
  var frequencyValue = props.frequencyValue;
  if (props.automataFrequency === "monthly") {
    if (props.radiobuttonvalue === "radiovalue1") {
      frequencyweek = "dateday";
      frequencyweekday = "";
      calendarname = "";
    } else if (props.radiobuttonvalue === "radiovalue2") {
      frequencyweek = props.frequencyWeek;
      frequencyweekday = props.frequencyWeekDay;
      calendarname = "";
    } else if (props.radiobuttonvalue === "radiovalue3") {
      frequencyweek = props.calendarNameOptions;
      frequencyweekday = "";
      calendarname = props.calendarName;
    }
  } else if (props.automataFrequency === "once") {
    frequencyweek = "";
    frequencyweekday = "";
    calendarname = "";
    frequencyValue = 1;
  } else if (props.automataFrequency === "yearly") {
    frequencyweek = "";
    frequencyweekday = "";
    calendarname = "";
  } else if (props.automataFrequency === "minutely") {
    if (props.calendarChecked) {
      frequencyweek = "";
      frequencyweekday = "";
      calendarname = props.calendarName;
    } else {
      frequencyweek = "";
      frequencyweekday = "";
      calendarname = "";
    }
  } else if (props.automataFrequency === "hourly") {
    if (props.calendarChecked) {
      frequencyweek = "";
      frequencyweekday = "";
      calendarname = props.calendarName;
    } else {
      frequencyweek = "";
      frequencyweekday = "";
      calendarname = "";
    }
  } else if (props.automataFrequency === "daily") {
    if (props.calendarChecked) {
      frequencyweek = "";
      frequencyweekday = "";
      calendarname = props.calendarName
    } else {
      frequencyweek = "";
      frequencyweekday = "";
      calendarname = "";
    }

  } else if (props.automataFrequency === "weekly") {
    if (props.radiobuttonvalueweekly === "radiovalueweekly1") {
      frequencyweek = "";
      frequencyweekday = "";
      calendarname = "";
    } else if (props.radiobuttonvalueweekly === "radiovalueweekly2") {
      frequencyweek = props.calendarNameOptions;
      frequencyweekday = "";
      calendarname = props.calendarName;
    }
  }
  let datatoElastic = {
    task: props.tasksArray,
    scheduleName: props.schedule
    ,onboard_automata_name: props.onboardAutomata
    , scheduleDescription: props.description
    , onboard_life_start_time: props.consolidatedTime
    , onboard_life_end_time: moment(props.endTimeFormat).toISOString()
    , automata_execution_time: props.automataExecutionTime
    , onboard_automata_frequency: props.currentOccurance.toLowerCase()
    , frequency_value: frequencyValue
    , frequency_week: frequencyweek
    , frequency_week_day: frequencyweekday
    , calendarName: calendarname
    , range_time_start: moment(props.between_start_time).format('HH:mm:ss')
    , range_time_start: moment(props.between_end_time).format('HH:mm:ss')
    , range_time_start: moment(props.between_start_time).format('HH:mm:ss')  //required
    , range_time_end: moment(props.between_end_time).format('HH:mm:ss')  //required
    , isScheduleExpires: true //TODO //required
    , franchise_name: props.franchise.key
    /* Todo required fields*/
    , apphostmachine_name: props.applicationServer.key //include in basic info
    , appstack_name: ""
    , party_name: props.client.key
    , action_flag: "Creation"
    , remdsn_code: "PROCESS_SCHEDULE"
    // , task: filtered
    //, onboard_preffered_hour: this.state.preffered_hour
  };
  function handleSubmit() {
    callPostApi(Constants.POSTSCHEDULESUBMIT, {
      'Content-Type': 'application/json'
    },
      datatoElastic,

      {
        onUploadProgress: ProgressEvent => {
          setWorkNotesRequest({
            upload_state: true,
            loaded: (ProgressEvent.loaded / ProgressEvent.total) * 100
          });
        }


      }
    )
      .then(response => {
        if (response) {
          //console.log(response.message)
          setMessage(response.message);
          history.push({
            pathname: '/scheduler/scheduleCreated'
          });
        }


      }).catch(error => {
        try {
          if (error.response.status === 401) {
            //console.log(error);
          }
        }
        catch (error) {
          //console.log("error " + (error));
        }
        //console.log('error ' + error);
      });
  };

  if (user !== null && user.access_token !== null) {
    return (
      <>
        <BasicInfo review={review} {...props} />
        <hr class="line-shadow"></hr>
        <SetFrequency review={review} {...props} />
        <hr class="line-shadow"></hr>
        <AddTask review={review} {...props} />
        {/* <hr class="line-shadow"></hr> */}
        <div className="reviewsubmitduration">
          <AddDuration review={review} {...props} />
        </div>
        <hr class="line-shadow"></hr>
        <div className="reviewsubmitduration">
          <RecommendResource className="reviewsubmitduration" review={review} {...props} />
          <hr class="line-shadow"></hr>
        </div>
        <Button kind="tertiary" className="review-submit-schedule" onClick={handleSubmit}>{submit}</Button>
      </>
    )
  } else {
    return (
      <div>
        <h2>{i18n.t('editScheduleRecommendation.please')}<a href={`https://development.aocc-staging-lon02-b3c-7dced0308bf9da27b6e714d1d05f7137-0000.eu-gb.containers.appdomain.cloud/login`}> {i18n.t('editScheduleRecommendation.signup')} </a> </h2>
      </div>
    );
  }



}